import {GenericContent} from "../models/GenericContent";
import {ALL_CONTENT} from "../constants/LearningPathsConfig";
import {REFERENCES_TYPES_CONFIG} from "../constants/ReferencesTypesConfig";
import {GAMES_TYPES_CONFIG} from "../constants/GamesTypesConfig";
import {CHALLENGES_TYPES_CONFIG} from "../constants/ChallengesTypesConfig";

export function getContentFromParams(contentType: string | undefined, contentName: string | undefined): GenericContent | null {
    let foundContent = null
    switch (contentType) {
        case 'courses':
            ALL_CONTENT.allCourses.map(category => {
                category.content.map(content => {
                    if (content.navUrl === contentName) {
                        foundContent = content
                    }
                })
            });
            break;
        case 'videos':
            ALL_CONTENT.allInterviews.map(category => {
                category.content.map(content => {
                    if (content.navUrl === contentName) {
                        foundContent = content
                    }
                })
            });
            break;
        case 'resources':
            ALL_CONTENT.allResources.map(category => {
                category.content.map(content => {
                    if (content.navUrl === contentName) {
                        foundContent = content
                    }
                })
            });
            break;
        case 'tools':
            ALL_CONTENT.allAITools.map(category => {
                category.content.map(content => {
                    if (content.navUrl === contentName) {
                        foundContent = content
                    }
                })
            });
            break;
        case 'blog':
            ALL_CONTENT.allBlogs.map(category => {
                category.content.map(content => {
                    if (content.navUrl === contentName) {
                        foundContent = content
                    }
                })
            });
            break;
        case 'references':
            REFERENCES_TYPES_CONFIG.forEach(reference => {
                if (reference.navUrl === contentName) {
                    foundContent = reference
                }
            });
            break;
        case 'games':
            GAMES_TYPES_CONFIG.forEach(game => {
                if (game.navUrl === contentName) {
                    foundContent = game
                }
            });
            break;
        case 'challenges':
            CHALLENGES_TYPES_CONFIG.forEach(challenge => {
                if (challenge.navUrl === contentName) {
                    foundContent = challenge
                }
            });
            break;
        case 'challenge-detail':
            // Handle individual challenge lookup by category and challenge ID
            const [categoryId, challengeId] = (contentName || '').split('/');
            CHALLENGES_TYPES_CONFIG.forEach(challenge => {
                if (challenge.navUrl === categoryId) {
                    const challengeItem = challenge.challengeItems.find(item => item.id === challengeId);
                    if (challengeItem) {
                        foundContent = challengeItem;
                    }
                }
            });
            break;
    }
    return foundContent
}
